import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import { makeStyles } from "@material-ui/core/styles";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import * as XLSX from "xlsx";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function VentaDirectaArchivoCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_DEVOLUCIONES = process.env.REACT_APP_URL_DEVOLUCIONES;
  const URL_ARTICULOS_DEVOLUCIONES = process.env.REACT_APP_URL_ARTICULOS_DEVOLUCIONES;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const AREAS_DEVOLUCIONES = process.env.REACT_APP_AREAS_DEVOLUCIONES;
  const AREAS_WALMART = process.env.REACT_APP_AREAS_WALMART_WFS;
  const URL_KILLERS = process.env.REACT_APP_URL_KILLERS;
  const URL_PROMOCIONES_WALMART = process.env.REACT_APP_URL_PROMOCIONES_WALMART;
  const AREAS_MELI = process.env.REACT_APP_AREAS_MELI_1_FULL;
  const AREAS_MELI_NOVA = process.env.REACT_APP_AREAS_MELI_2_FULL;
  const AREAS_AMAZON = process.env.REACT_APP_AREAS_AMAZON_1_FBA;
  const AREAS_AMAZON_YOU = process.env.REACT_APP_AREAS_AMAZON_2_FBA;
  const PASSWORD_CAMBIA_PRECIO = process.env.REACT_APP_PASSWORD_CAMBIA_PRECIO;
  const URL_SEND_MAIL = process.env.REACT_APP_URL_SEND_MAIL;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  // const [idsArticulos, setIdsArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [sucursales, setSucursales] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState([]);
  const [sucursal, setSucursal] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedColaboradorName, setSelectedColaboradorName] = useState("");
  const [value, setValue] = useState("");
  const [articulosUnicos, setArticulosUnicos] = useState([]);
  const [articulosCatalogo, setArticulosCatalogo] = useState([]);
  const [totalCaptura, setTotalCaptura] = useState(1);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [inventarios, setInventarios] = useState([]);
  // El concentrado de un marketplace se parte en tres:
  //   inputFields    -> vendido desde la bodega del marketplace (venta directa)
  //   lineasCedis    -> dropship: sale de CEDIS, solo se crea el pedido
  //   lineasDevolucion -> devoluciones, entran al almacen Devoluciones
  const [invCedis, setInvCedis] = useState([]);
  const [lineasCedis, setLineasCedis] = useState([]);
  const [lineasDevolucion, setLineasDevolucion] = useState([]);
  const [resumenImport, setResumenImport] = useState(null);

  const [cliente, setCliente] = useState("");
  const [condPago, setCondPago] = useState("Contado");
  const [departamentoCliente, setDepartamentoCliente] = useState("");
  const [paqueterias, setPaqueterias] = useState([]);
  const [paqueteria, setPaqueteria] = useState("NA");
  const [idPaqueteria, setIdPaqueteria] = useState("650b273bc9855e3f883e8f5d");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState(AREAS_MELI);
  const [selectedAreaName, setSelectedAreaName] = useState("Mercado Libre");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [descuentoNumero, setDescuentoNumero] = useState(0);

  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [total_cajas, setTotalCajas] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);

  // const [descuento, setDescuento] = useState(0);
  // const [descuentoNumero, setDescuentoNumero] = useState(0);

  const [listaPrecios, setListaPrecios] = useState(1);

  const [bancos, setBancos] = useState([]);
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());

  const [pago, setPago] = useState();
  const [efectivo, setEfectivo] = useState(0);
  const [tdc, setTDC] = useState(0);
  const [transfer, setTransfer] = useState(0);
  const [fechaTransfer, setFechaTransfer] = useState("NA");
  const [referencia, setReferencia] = useState("NA");
  const [destino, setDestino] = useState("NA");
  const [terminal, setTerminal] = useState("Tarjeta");
  const [saldo, setSaldo] = useState(0);

  const classes = useStyles();
   const [inputFields, setInputFields] = useState([]);
  // const [inputFields, setInputFields] = useState([
  //   {
  //     id: uuidv4(),
  //     articulos: "",
  //     piezasPorCaja: 0,
  //     cajas: 0,
  //     cantidad: 0,
  //     precio: 0,
  //     precioBruto: 0,
  //     precioOriginal: 0,
  //     total: 0,
  //     articulosNombre: "",
  //     observacionesArticulo: "NA",
  //     idInv: "",
  //     costoUnitario: 0,
  //     cantInv: 0,
  //   },
  // ]);

  const [validaBoton, setValidaBoton] = useState(true);
  const [cambiarPrecio, setCambiarPrecio] = useState(false);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  const [mailAutEnviado, setMailAutEnviado] = useState(false);
  const [randomCambiaPrecio, setRandomCambiaPrecio] = useState(
    (Math.random() + 1).toString(36).substring(2)
  );

  useMemo(() => {
    axios
      .get(`${URL_ARTICULOS}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosCat = res.data;
        setArticulosCatalogo(allArticulosCat);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_CLIENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_PAQUETERIAS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allPaqueterias = res.data;
    //     setPaqueterias(allPaqueterias);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_INVENTARIOS}AcumuladoAlmacenVD/${AREAS_CEDIS}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((r) => setInvCedis(r.data))
      .catch((err) => console.log(err));

    if (selectedArea) {
      axios
        .get(`${URL_INVENTARIOS}AcumuladoAlmacenVD/${selectedArea}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allDisponible = response.data;
          setInventarios(allDisponible);

          setArticulos(allDisponible);
          // let result = allDisponible.map((a) => a.idArticulo);
          // setIdsArticulos(result);

          let unicos = allDisponible.filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.idArticulo === value.idArticulo)
          );
          setArticulosUnicos(unicos);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });

    // if(selectedCliente == "650a334ab99f0b3555a8cf16"){
    //   axios
    //   .get(`${URL_CLIENTES}/${selectedCliente}`, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allCliente = res.data;
    //     setCliente(allCliente);
    //     // setDescuento(allCliente.descuento);
    //     setListaPrecios(allCliente.listaPrecios);
    //     setSelectedColaborador(allCliente.vendedor[0]._id);
    //     setSelectedColaboradorName(allCliente.vendedor[0].nombre + " " + allCliente.vendedor[0].apellido);
    //     setDepartamentoCliente(allCliente.departamentosClientes[0]._id);
    //     setCondPago(allCliente.forma_pago);
    //     if(allCliente.forma_pago == "Credito"){
    //       setPago(false)
    //     }else setPago(true)
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    // }
  }, [selectedArea]);


  const cantidadesAgrupadas = {};
inputFields.forEach((a) => {
  const id = a.articulos;
  if (!cantidadesAgrupadas[id]) {
    cantidadesAgrupadas[id] = {
      totalCantidad: 0,
      cantInv: parseFloat(a.cantInv),
    };
  }
  cantidadesAgrupadas[id].totalCantidad += parseFloat(a.cantidad);
});


  const [killersActivos, setKillersActivos] = useState([]);
  const [promoActivas, setPromoActivas] = useState([]);

// Crea un Set con los IDs que están sobrepasados
const articulosExcedidos = new Set(
  Object.entries(cantidadesAgrupadas)
    .filter(([_, val]) => val.totalCantidad > val.cantInv)
    .map(([id]) => id)
);


  const auth = () => ({
    headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
  });

  // Dropship: sale de CEDIS. Solo se crea el pedido, abierto y pendiente de
  // surtir, para poder surtirlo despues desde el sistema. No toca inventario.
  const guardaPedidoCedis = async () => {
    if (!lineasCedis.length) return;
    const cantidad = lineasCedis.reduce((t, a) => t + parseFloat(a.cantidad), 0);
    const importe = lineasCedis.reduce((t, a) => t + parseFloat(a.total), 0);
    const { data: ped } = await axios.post(URL_PEDIDOS, {
      fecha,
      clientes: selectedCliente,
      departamentosClientes: departamentoCliente,
      colaboradores: selectedColaborador,
      total_general: importe.toFixed(2),
      observaciones: `${observaciones} | Dropship desde CEDIS`,
      total_cantidad: cantidad,
      paqueterias: "665e148c225a1c1e3f506999",
      areas: AREAS_CEDIS,
      sucursales: sucursal,
      comisionTDC, comisionFlete,
      subTotal: importe.toFixed(2),
      iva: 0,
      impuestos: selectedImpuesto,
      surtido: "No",
      autorizadoApartado: "Si",
      autorizadoSurtido: "Si",
      editado: "No",
      fechaModificado: fecha,
      creado: user.id,
      fecha_estimada: fecha,
      fecha_entrega: fecha,
      entregaInsumos: "No",
    }, auth());

    for (const a of lineasCedis) {
      await axios.post(URL_ARTICULOS_PEDIDO, {
        pedidos: ped._id,
        articulos: a.articulos,
        cantidad: parseFloat(a.cantidad),
        cantidadProcesos: 0,
        surtido: 0,
        pendiente_surtir: parseFloat(a.cantidad),
        precio: parseFloat(a.precio).toFixed(2),
        precioBruto: parseFloat(a.precioBruto).toFixed(2),
        total: parseFloat(a.total).toFixed(2),
        cliente: cliente || "NA",
        variante: a.variante || null,
      }, auth());
    }
  };

  // Devoluciones: el producto regresa al almacen Devoluciones para revisarse.
  const guardaDevolucion = async () => {
    if (!lineasDevolucion.length) return;
    const cantidad = lineasDevolucion.reduce((t, a) => t + parseFloat(a.cantidad), 0);
    const importe = lineasDevolucion.reduce((t, a) => t + parseFloat(a.total), 0);
    const { data: dev } = await axios.post(URL_DEVOLUCIONES, {
      fecha,
      clientes: selectedCliente,
      colaboradores: selectedColaborador,
      areas: AREAS_DEVOLUCIONES,
      observaciones: `${observaciones} | Devoluciones del concentrado`,
      total_general: importe.toFixed(2),
      total_cantidad: cantidad,
      subTotal: importe.toFixed(2),
      iva: 0,
      impuestos: selectedImpuesto,
      aplicada: "No",
    }, auth());

    for (const a of lineasDevolucion) {
      await axios.post(URL_ARTICULOS_DEVOLUCIONES, {
        devoluciones: dev._id,
        fecha,
        articulos: a.articulos,
        cantidad: parseFloat(a.cantidad),
        defectos: 0,
        totalPiezas: parseFloat(a.cantidad),
        precio: parseFloat(a.precio).toFixed(2),
        total: parseFloat(a.total).toFixed(2),
        areas: AREAS_DEVOLUCIONES,
        lote: "NA",
        costoUnitario: a.costoUnitario || 0,
        variante: a.variante || null,
      }, auth());
    }
  };

const savePedido = async (event) => {
  event.preventDefault();

  // Agrupar cantidades por artículo
  const cantidadesAgrupadas = {};
  inputFields.forEach((a) => {
    const id = a.articulos;
    if (!cantidadesAgrupadas[id]) {
      cantidadesAgrupadas[id] = {
        totalCantidad: 0,
        cantInv: parseFloat(a.cantInv),
        SKU: a.SKU || "SKU no definido",
      };
    }
    cantidadesAgrupadas[id].totalCantidad += parseFloat(a.cantidad);
  });

  // Solo se valida el stock de la bodega del marketplace: el dropship de CEDIS
  // no descuenta aqui, se surte despues desde el sistema.
  const sinInventario = Object.values(cantidadesAgrupadas).filter(
    (a) => a.totalCantidad > a.cantInv
  );

  if (sinInventario.length > 0) {
    const detalles = sinInventario
      .map(
        (a) =>
          `<li><b>${a.SKU}</b> — solicitado: ${a.totalCantidad}, inventario: ${a.cantInv}</li>`
      )
      .join("");

    Swal.fire({
      icon: "error",
      title: "Oops...",
      html:
        "La suma de cantidad para los siguientes artículos sobrepasa el inventario disponible:<br><ul>" +
        detalles +
        "</ul>",
    });
    return;
  }

  // Validar precios > 0
  const preciosInvalidos = inputFields.filter((a) => parseFloat(a.precio) <= 0);
  if (preciosInvalidos.length > 0) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Hay artículos con precio menor o igual a 0. Verifica antes de guardar.",
    });
    return;
  }

  if (selectedCliente != "" && selectedArea != "") {
    setValidaBoton(false);
    toggleProgreso();
    let totalPedido = inputFields.length;
    try {
      const { data: dataPedido } = await axios.post(
        URL_PEDIDOS,
        {
          fecha,
          clientes: selectedCliente,
          departamentosClientes: departamentoCliente,
          colaboradores: selectedColaborador,
          total_general: parseFloat(total_general).toFixed(2),
          observaciones,
          total_cantidad,
          paqueterias: "665e148c225a1c1e3f506999",
          areas: selectedArea,
          sucursales: sucursal,
          comisionTDC,
          comisionFlete,
          subTotal: parseFloat(subTotal).toFixed(2),
          iva: parseFloat(iva).toFixed(2),
          impuestos: selectedImpuesto,
          surtido: "Si",
          autorizadoApartado: "Si",
          autorizadoSurtido: "Si",
          editado: "No",
          fechaModificado: fecha,
          creado: user.id,
          fecha_estimada: fecha,
          fecha_entrega: fecha,
          entregaInsumos: "No",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      const { data: dataSurtido } = await axios.post(
        URL_SURTIDOS,
        {
          fecha,
          pedidos: dataPedido._id,
          observaciones,
          user: user.id,
          clientes: selectedCliente,
          areas: selectedArea,
          total_general: parseFloat(total_general).toFixed(2),
          saldo: parseFloat(saldo).toFixed(2),
          subTotal: parseFloat(subTotal).toFixed(2),
          iva: parseFloat(iva).toFixed(2),
          impuestos: selectedImpuesto,
          is_active: "Si",
          entregado: "Si",
          paqueterias: "665e148c225a1c1e3f506999",
          colaboradores: selectedColaborador,
          comisionPagada: "No",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      for (const a of inputFields) {
        if (a.articulos && a.cantidad > 0) {
          try {
            const { data: dataArtPed } = await axios.post(
              URL_ARTICULOS_PEDIDO,
              {
                pedidos: dataPedido._id,
                articulos: a.articulos,
                cantidad: parseFloat(a.cantidad),
                cantidadProcesos: 0,
                pendiente_surtir: 0,
                surtido: parseFloat(a.cantidad),
                precio: parseFloat(a.precio).toFixed(2),
                precioBruto: parseFloat(a.precioBruto).toFixed(2),
                total: parseFloat(a.total).toFixed(2),
                cliente: "NA",
                variante: a.variante || null,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );

            await axios.post(
              `${URL_ARTICULOS_SURTIDOS}/ventaDirecta`,
              {
                fecha,
                surtidos: dataSurtido._id,
                inventarios: a.idInv,
                cantidad: parseFloat(a.cantidad),
                articulos: a.articulos,
                pedidos: dataPedido._id,
                articulosPedido: dataArtPed._id,
                costoUnitario: a.costoUnitario,
                clientes: selectedCliente,
                areas: selectedArea,
                precio: parseFloat(a.precio).toFixed(2),
                precioBruto: parseFloat(a.precioBruto).toFixed(2),
                paqueterias: "665e148c225a1c1e3f506999",
                porEntregar: 0,
                entregadoCantidad: a.cantidad,
                entregado: "Si",
                variante: a.variante || null,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
          } catch (error) {
            console.error(error);
            Swal.fire({
              icon: "error",
              title: "Error en artículo",
              text: "Hubo un problema al guardar un artículo.",
            });
            setValidaBoton(true);
            return;
          }
        }
        totalPedido--;

        if (totalPedido === 0) {
          await guardaPedidoCedis();
          await guardaDevolucion();
          await axios.post(
            URL_LOGS,
            {
              tipo: "Crear Pedido",
              detalle: `${value._id} ${total_general}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          Swal.fire("Good job!", "Creado con éxito", "success");
          setTimeout(() => window.location.reload(), 1000);
        }
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response?.data || ""}`,
      });
      setValidaBoton(true);
    }
  } else {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Faltan datos, favor de revisar",
    });
  }
};


  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        precioBruto: 0,
        precioOriginal: 0,
        total: 0,
        articulosNombre: "",
        observacionesArticulo: "NA",
        idInv: "",
        costoUnitario: 0,
        cantInv: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let totalCan = values.map((c) => parseFloat(c.cantidad));
    let TC = totalCan.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let totalCajas = values.map((c) => parseFloat(c.cajas));
    let TCajas = totalCajas.reduce((t, total, index) => t + total, 0);
    setTotalCajas(TCajas);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }
    let temp1 = (TG * descuento) / 100;

    setDescuentoNumero(temp1);

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      parseFloat(temp1);

    setTotalGeneral(totTemp);
  };

  const handleChangeInputObservaciones = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.observacionesArticulo = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecio = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[name] = value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cajas = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if (i.cantInv >= event.target.value) {
          i.cantidad = parseFloat(event.target.value);
          i.cajas = (
            parseFloat(event.target.value) / parseFloat(i.piezasPorCaja)
          ).toFixed(2);
          let totalParcial = i.cantidad * i.precio;
          i.total = totalParcial;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede tu inventario!",
            showConfirmButton: false,
          });
          i.cajas = 0;
          i.cantidad = 0;
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let totalKG = inputFields.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let totalCajas = inputFields.map((c) => parseFloat(c.cajas));
    let TCajas = totalCajas.reduce((t, total, index) => t + total, 0);
    setTotalCajas(TCajas);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }
    let temp1 = (TG * descuento) / 100;

    setDescuentoNumero(temp1);

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      parseFloat(temp1);

    setTotalGeneral(totTemp);

    setSaldo(totTemp - efectivo - tdc - transfer);
  }


  function jalaCliente(cliente) {
    // setInputFields([
    //   {
    //     id: uuidv4(),
    //     articulos: "",
    //     piezasPorCaja: 0,
    //     cajas: 0,
    //     cantidad: 0,
    //     precio: 0,
    //     precioOriginal: 0,
    //     total: 0,
    //     articulosNombre: "",
    //     observacionesArticulo: "NA",
    //     idInv: "",
    //     costoUnitario:0
    //   },
    // ]);

    setSelectedCliente(cliente);

    axios
      .get(`${URL_CLIENTES}/${cliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCliente = res.data;
        setCliente(allCliente);
        setSelectedColaborador(allCliente.vendedor[0]._id);
        setSelectedColaboradorName(
          allCliente.vendedor[0].nombre + " " + allCliente.vendedor[0].apellido
        );
        setDepartamentoCliente(allCliente.departamentosClientes[0]._id);
        // setCondPago(allCliente.forma_pago);
        // if(allCliente.forma_pago == "Credito"){
        //   setPago(false)
        // }else setPago(true)
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_SUCURSALES}/clientes/${cliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allSucursales = res.data;
        setSucursales(allSucursales);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function jalaSucursal(value) {
    let split = value.split(",");
    let dir = split[0];
    let paq = split[1];

    setSelectedSucursal(value);
    setSucursal(dir);
  }

  function calculaImpuesto(e) {
    setSelectedImpuesto(e);
    if (e != 0) {
      setIva((e * subTotal) / 100);
    } else {
      setIva(0);
    }

    setTotalGeneral(
      (e * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );

    setSaldo(
      (e * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete) -
        efectivo -
        tdc -
        transfer
    );
  }


  function autorizaCambio() {
    if (password == PASSWORD_CAMBIA_PRECIO) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  function jalaArea(e) {
    setSelectedArea(e);
    areas.map((a) => {
      if (a._id == e) {
        setSelectedAreaName(a.name);
      }
    });
  }

  // ─────────── Concentrados crudos de marketplace ───────────
  // Meli: dos hojas por cuenta, encabezado en la fila 6, se mapea por # de publicacion (MLM).
  // Walmart: hoja "Detalles Del Pedido", se mapea por WUPC.
  // Solo descuentan inventario las ventas entregadas o en camino; los cancelados
  // se ignoran y las devoluciones entran al almacen Devoluciones.
  const ESTADOS_VENTA = ["ENTREGADO", "VENTA ENTREGADA", "EMBARCADO", "LISTO PARA EMBARCAR"];
  const ESTADOS_DEVOLUCION = ["DEVOLUCIÓN", "DEVOLUCION", "MEDIACIÓN", "MEDIACION"];
  const MESES_ES = ["enero","febrero","marzo","abril","mayo","junio","julio",
                    "agosto","septiembre","octubre","noviembre","diciembre"];

  const norm = (v) => String(v ?? "").trim().toUpperCase();
  const clasificaEstado = (estado) => {
    const e = norm(estado);
    if (ESTADOS_VENTA.includes(e)) return "venta";
    if (ESTADOS_DEVOLUCION.some((d) => e.includes(d))) return "devolucion";
    return "ignorado";
  };

  // indice clave -> registro de inventario, para un almacen dado
  const indicePor = (lista, campo) => {
    const m = {};
    (lista || []).forEach((a) => {
      const codigos = Array.isArray(a[campo]) ? a[campo] : a[campo] ? [a[campo]] : [];
      codigos.forEach((c) => { if (c) m[norm(c)] = a; });
    });
    return m;
  };

  const nuevaLinea = (art, cantidad, precio) => ({
    id: uuidv4(),
    articulos: art.idArticulo,
    piezasPorCaja: 0,
    cajas: 0,
    cantidad,
    precio: Number(precio.toFixed(2)),
    precioBruto: Number(precio.toFixed(2)),
    precioOriginal: art.venta,
    total: Number((cantidad * precio).toFixed(2)),
    articulosNombre: `${art.SKU || ""} ${art.nombre || ""} ${art.variante || ""}`.trim(),
    observacionesArticulo: "NA",
    idInv: art._id,
    costoUnitario: art.costoUnitario,
    cantInv: art.cantidad,
    variante: art.idVariante || null,
    SKU: art.SKU,
  });

  // acumula por variante para no generar un renglon por venta
  const acumula = (mapa, art, cantidad, importe) => {
    const k = art._id;
    if (!mapa[k]) mapa[k] = { art, cantidad: 0, importe: 0 };
    mapa[k].cantidad += cantidad;
    mapa[k].importe += importe;
  };
  const aLineas = (mapa) => Object.values(mapa).map(({ art, cantidad, importe }) =>
    nuevaLinea(art, cantidad, cantidad ? importe / cantidad : 0));

  function importarConcentrado(event, origen) {
    const target = event.target;
    if (target.name !== "file" || !target.files[0]) return;
    const reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);
    reader.onloadend = (e) => {
      try {
        const workbook = XLSX.read(new Uint8Array(e.target.result), { type: "array" });
        const idxMkt = indicePor(inventarios, origen === "meli" ? "mlmList" : "wupcList");
        const idxCedis = indicePor(invCedis, origen === "meli" ? "mlmList" : "wupcList");
        const idxDev = indicePor(inventarios, origen === "meli" ? "mlmList" : "wupcList");

        const mkt = {}, cedis = {}, dev = {};
        const noEncontrados = new Set();
        let nVenta = 0, nDev = 0, nIgnorado = 0;

        const hojas = origen === "meli"
          ? workbook.SheetNames.filter((n) => norm(n).includes("VENTAS"))
          : workbook.SheetNames.filter((n) => norm(n).includes("DETALLES"));

        hojas.forEach((hoja) => {
          // Meli trae 5 filas de encabezado antes de la tabla
          const filas = XLSX.utils.sheet_to_json(workbook.Sheets[hoja],
            origen === "meli" ? { range: 5 } : {});
          filas.forEach((r) => {
            const clave = norm(origen === "meli" ? r["# de publicación"] : r["WUPC"]);
            if (!clave || clave === "UNDEFINED") return;
            const cantidad = parseFloat(origen === "meli" ? r["Unidades"] : r["Cantidad"]) || 0;
            if (!cantidad) return;
            const precio = parseFloat(origen === "meli"
              ? r["Precio unitario de venta de la publicación (MXN)"] : r["Precio"]) || 0;

            const tipo = clasificaEstado(r["Estado"]);
            if (tipo === "ignorado") { nIgnorado += cantidad; return; }

            // Walmart: lo que no es WFS es dropship y sale de CEDIS
            const deCedis = origen === "walmart" && norm(r["Entidad de cumplimiento"]) !== "WFS";
            // Para el dropship basta con identificar el articulo: no se descuenta
            // stock, solo se crea el pedido. Por eso si CEDIS no tiene registro de
            // inventario se cae al indice del marketplace en vez de perder la linea.
            const idx = tipo === "devolucion" ? idxDev : deCedis ? idxCedis : idxMkt;
            const art = idx[clave] || idxMkt[clave] || idxCedis[clave];
            if (!art) { noEncontrados.add(clave); return; }

            if (tipo === "devolucion") { acumula(dev, art, cantidad, precio * cantidad); nDev += cantidad; }
            else if (deCedis) { acumula(cedis, art, cantidad, precio * cantidad); nVenta += cantidad; }
            else { acumula(mkt, art, cantidad, precio * cantidad); nVenta += cantidad; }
          });
        });

        const lineasMkt = aLineas(mkt);
        setInputFields(lineasMkt);
        setLineasCedis(aLineas(cedis));
        setLineasDevolucion(aLineas(dev));
        setResumenImport({
          origen, venta: nVenta, devolucion: nDev, ignorado: nIgnorado,
          mkt: lineasMkt.reduce((t, a) => t + a.cantidad, 0),
          cedis: aLineas(cedis).reduce((t, a) => t + a.cantidad, 0),
          noEncontrados: [...noEncontrados],
        });

        if (noEncontrados.size) {
          Swal.fire({
            icon: "warning",
            title: "Claves sin artículo",
            html: `No se encontraron en el catálogo:<br><b>${[...noEncontrados].slice(0, 15).join("<br>")}</b>` +
                  (noEncontrados.size > 15 ? `<br>… y ${noEncontrados.size - 15} más` : ""),
          });
        }
        ActualizaTotales();
      } catch (err) {
        console.log(err);
        Swal.fire({ icon: "error", title: "No se pudo leer el archivo", text: String(err.message || err) });
      }
    };
  }

  function importarArchivo(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];

    if (name === "file") {
      let reader = new FileReader();
      reader.readAsArrayBuffer(target.files[0]);
      reader.onloadend = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (sheetName) {
          // Here is your object
          var XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          hojas.push({
            data: XL_row_object,
            sheetName,
          });
        });

        let A1 = hojas[0].data;

        // Mapear cada MLM (del array de la variante) → registro de inventario
        const articulosMap = {};
        inventarios.forEach((articulo) => {
          const mlms = Array.isArray(articulo.mlmList) && articulo.mlmList.length
            ? articulo.mlmList
            : (articulo.MLM ? [articulo.MLM] : []);
          mlms.forEach(mlm => {
            if (mlm) articulosMap[String(mlm).trim().toUpperCase()] = articulo;
          });
        });

        const articulosNoEncontrados = [];

        // Iterar sobre A1 una sola vez
        for (const a of A1) {
          const key = String(a.MLM || "").trim().toUpperCase();
          const articulo = articulosMap[key];
          if (articulo) {
            inputFields.push({
              id: uuidv4(),
              articulos: articulo.idArticulo,
              piezasPorCaja: 0,
              cajas: 0,
              cantidad: a.Unidades,
              precio: parseFloat((a.Precio / a.Unidades).toFixed(2)),
              precioBruto: a.PrecioBruto,
              precioOriginal: articulo.venta,
              total: a.Precio,
              articulosNombre: (articulo.mlmList?.[0] || articulo.MLM || "") + " " + articulo.nombre + " " + (articulo.variante || ""),
              observacionesArticulo: "NA",
              idInv: articulo._id,
              costoUnitario: articulo.costoUnitario,
              cantInv: articulo.cantidad,
              variante: articulo.idVariante || null,
            });
          } else {
            articulosNoEncontrados.push(a.MLM);
          }
        }

        // Verificar si se encontraron artículos que no estaban en el mapa
        if (articulosNoEncontrados.length > 0) {
          const mensaje = `Los siguientes MLM no se encontraron: ${articulosNoEncontrados.join(
            ", "
          )}`;
          Swal.fire({
            title: "Artículos no encontrados",
            text: mensaje,
            icon: "warning",
            button: "Entendido",
          });
        }

        ActualizaTotales();
      };
    }
  }

  function importarArchivoAmazon(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];

    if (name === "file") {
      let reader = new FileReader();
      reader.readAsArrayBuffer(target.files[0]);
      reader.onloadend = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (sheetName) {
          // Here is your object
          var XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          hojas.push({
            data: XL_row_object,
            sheetName,
          });
        });

        let A1 = hojas[0].data;

        // Mapear cada ASIN (del array de la variante) → registro de inventario
        const articulosMap = {};
        inventarios.forEach((articulo) => {
          const asins = Array.isArray(articulo.asinList) && articulo.asinList.length
            ? articulo.asinList
            : (articulo.ASIN ? [articulo.ASIN] : []);
          asins.forEach(asin => {
            if (asin) articulosMap[String(asin).trim().toUpperCase()] = articulo;
          });
        });

        const articulosNoEncontrados = [];

        // Iterar sobre A1 una sola vez
        for (const a of A1) {
          const key = String(a.ASIN || "").trim().toUpperCase();
          const articulo = articulosMap[key];
          if (articulo) {
            inputFields.push({
              id: uuidv4(),
              articulos: articulo.idArticulo,
              piezasPorCaja: 0,
              cajas: 0,
              cantidad: a.Unidades,
              precio: a.Precio,
              precioBruto: a.PrecioBruto,
              precioOriginal: articulo.venta,
              total: a.Precio * a.Unidades,
              articulosNombre: (articulo.asinList?.[0] || articulo.ASIN || "") + " " + articulo.nombre + " " + (articulo.variante || ""),
              observacionesArticulo: "NA",
              idInv: articulo._id,
              costoUnitario: articulo.costoUnitario,
              cantInv: articulo.cantidad,
              variante: articulo.idVariante || null,
            });
          } else {
            articulosNoEncontrados.push(a.ASIN);
          }
        }

        // Verificar si se encontraron artículos que no estaban en el mapa
        if (articulosNoEncontrados.length > 0) {
          const mensaje = `Los siguientes ASIN no se encontraron: ${articulosNoEncontrados.join(
            ", "
          )}`;
          Swal.fire({
            title: "Artículos no encontrados",
            text: mensaje,
            icon: "warning",
            button: "Entendido",
          });
        }

        ActualizaTotales();
      };
    }
  }



  // Fetch killers y promociones activas cuando el área es Walmart
  useEffect(() => {
    if (selectedArea === AREAS_WALMART) {
      const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
      axios.get(URL_KILLERS, auth).then((r) => setKillersActivos(r.data)).catch(console.log);
      axios.get(`${URL_PROMOCIONES_WALMART}/activas`, auth).then((r) => setPromoActivas(r.data)).catch(console.log);
    } else {
      setKillersActivos([]);
      setPromoActivas([]);
    }
  }, [selectedArea]);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          {/* Toolbar */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, marginTop: 8 }}>
            <h4 style={{ margin: 0 }}>
              📁 Venta Directa por Archivo
              <span style={{ background: "#dbeafe", color: "#1e3a8a", borderRadius: 20, padding: "3px 14px", fontWeight: 700, fontSize: "0.85rem", marginLeft: 10 }}>
                {inputFields.length} artículos
              </span>
            </h4>
            <Button size="sm" color="danger" href="/MenuVentas">← Regresar</Button>
          </div>

          {/* Encabezado */}
          <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 16px", marginBottom: 14 }}>
            <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>📋 Encabezado</div>
            <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input type="date" placeholder="Fecha" value={fecha} required onChange={(e) => { setFecha(e.target.value); }} />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Cliente</Label>
                <Input className="col-sm-12" type="select" value={selectedCliente} required onChange={(e) => { jalaCliente(e.target.value); }}>
                  <option value="0">Selecciona</option>
                  {clientes.sort((a, b) => a.nombre_comercial > b.nombre_comercial ? 1 : -1).map((a) => (
                    <option key={a._id} value={a._id}>{a.nombre_comercial}</option>
                  ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Sucursal</Label>
                <Input type="select" value={selectedSucursal} onChange={(e) => { jalaSucursal(e.target.value); }}>
                  <option value="">Selecciona una Sucursal</option>
                  {sucursales.sort((a, b) => a.alias > b.alias ? 1 : -1).map((a) => {
                    if (a.is_active == "Si") {
                      return <option key={a._id} value={[a._id]}>{a.alias}</option>;
                    }
                  })}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Vendedor</Label>
                <Input type="select" value={selectedColaborador} disabled>
                  <option value="">Selecciona un Vendedor</option>
                  {colaboradores.sort((a, b) => a.nombre > b.nombre ? 1 : -1).map((a) => (
                    <option key={a._id} value={a._id}>{a.nombre} {a.apellido}</option>
                  ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Almacén</Label>
                <Input type="select" value={selectedArea} onChange={(e) => { jalaArea(e.target.value); }}>
                  <option value="">Selecciona un almacen</option>
                  {areas.sort((a, b) => a.name > b.name ? 1 : -1).map((a) => {
                    if (a._id == AREAS_AMAZON || a._id == AREAS_AMAZON_YOU || a._id == AREAS_MELI || a._id == AREAS_MELI_NOVA || a._id == AREAS_CEDIS || a._id == AREAS_WALMART) {
                      return <option key={a._id} value={a._id}>{a.name}</option>;
                    }
                  })}
                </Input>
              </Col>
            </Row>
          </div>

          {/* Observaciones */}
          <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 16px", marginBottom: 14 }}>
            <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>📝 Observaciones</div>
            <Row>
              <Col md={7}>
                <Input type="textarea" placeholder="Observaciones" value={observaciones} required onChange={(e) => { setObservaciones(e.target.value); }} />
              </Col>
              <Col md={2} className="d-flex align-items-end">
                <div>
                  <Label>Cambio de Precio</Label>
                  <br />
                  <Button size="sm" color="info" onClick={() => toggleCambiaPrecio()}>Solicitar</Button>
                </div>
              </Col>
            </Row>
          </div>

          {/* Totales */}
          <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 16px", marginBottom: 14 }}>
            <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>💰 Totales</div>
            <Row>
              <Col md={1}>
                <Label>Impuestos %</Label>
                <Input type="number" min="0" step="any" value={selectedImpuesto} onChange={(e) => { calculaImpuesto(e.target.value); }} />
              </Col>
              <Col md={2}>
                <Label>Sub Total</Label>
                <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" placeholder="Ingresa una cantidad" defaultValue={0} decimalsLimit={2} value={subTotal} disabled className="form-control form-control-sm" />
              </Col>
              <Col md={2}>
                <Label>IVA</Label>
                <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" placeholder="Ingresa una cantidad" defaultValue={0} decimalsLimit={2} value={iva} disabled className="form-control form-control-sm" />
              </Col>
              <Col md={2}>
                <Label>Total</Label>
                <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" placeholder="Ingresa una cantidad" defaultValue={0} decimalsLimit={2} value={total_general} disabled className="form-control form-control-sm" />
              </Col>
              <Col md={1}>
                <Label>Piezas</Label>
                <Input type="number" min="0" step="any" placeholder="Piezas" value={total_cantidad} required disabled />
              </Col>
            </Row>
          </div>

          {/* Cargar Archivo */}
          <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 16px", marginBottom: 14 }}>
            <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>📂 Cargar Archivo</div>
            <Row>
              {selectedArea == AREAS_MELI || selectedArea == AREAS_MELI_NOVA ? (
                <>
                  <Col md={3}>
                    <Label>Concentrado Mercado Libre</Label>
                    <Input required type="file" name="file" id="fileMeli" onChange={(e) => importarConcentrado(e, "meli")} />
                    <small className="text-muted">Archivo tal cual lo descargas de Meli</small>
                  </Col>
                  <Col md={3}>
                    <Label>Archivo simple (MLM)</Label>
                    <Input type="file" name="file" id="file" onChange={(event) => importarArchivo(event)} />
                  </Col>
                </>
              ) : selectedArea == AREAS_WALMART ? (
                <Col md={4}>
                  <Label>Concentrado Walmart</Label>
                  <Input required type="file" name="file" id="fileWmt" onChange={(e) => importarConcentrado(e, "walmart")} />
                  <small className="text-muted">Separa solo WFS de dropship automáticamente</small>
                </Col>
              ) : selectedArea == AREAS_AMAZON || selectedArea == AREAS_AMAZON_YOU ? (
                <Col md={4}>
                  <Label>Archivo Amazon</Label>
                  <Input required type="file" name="file" id="file" onChange={(event) => importarArchivoAmazon(event)} />
                </Col>
              ) : (
                <Col md={5}>
                  <small className="text-muted">Selecciona un almacén para cargar el archivo correspondiente.</small>
                </Col>
              )}
            </Row>
          </div>

          {resumenImport ? (
            <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "10px 16px", marginBottom: 14, fontSize: "0.83rem" }}>
              <b style={{ color: "#1e3a8a" }}>Así quedó el archivo</b>
              <div style={{ display: "flex", gap: 24, flexWrap: "wrap", marginTop: 6 }}>
                <span>Bodega {selectedAreaName}: <b>{resumenImport.mkt}</b> pzas — se surte ahora</span>
                <span>Dropship CEDIS: <b>{resumenImport.cedis}</b> pzas — solo pedido, se surte después</span>
                <span>Devoluciones: <b>{resumenImport.devolucion}</b> pzas — entran a Devoluciones</span>
                <span style={{ color: "#64748b" }}>Cancelados omitidos: {resumenImport.ignorado} pzas</span>
                {resumenImport.noEncontrados.length ? (
                  <span style={{ color: "#b91c1c" }}>Sin artículo: {resumenImport.noEncontrados.length} claves</span>
                ) : null}
              </div>
            </div>
          ) : null}

          {/* Artículos */}
          <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 16px", marginBottom: 14 }}>
            <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>📦 Artículos</div>
            <Table size="sm" bordered striped className="table-responsive-xl" style={{ fontSize: "0.82rem" }}>
              <thead className="thead-light">
                <tr>
                  <th>Artículo</th>
                  <th style={{ maxWidth: "60px" }}>Inventario</th>
                  <th style={{ maxWidth: "60px" }}>Cantidad</th>
                  <th style={{ maxWidth: "60px" }}>Precio Original</th>
                  <th style={{ maxWidth: "60px" }}>Precio</th>
                  <th style={{ maxWidth: "60px" }}>Precio Bruto</th>
                  <th style={{ maxWidth: "80px" }}>Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {inputFields.map((inputField) => (
                  <tr key={inputField.id} style={articulosExcedidos.has(inputField.articulos) ? { backgroundColor: "#ed8c8c" } : undefined}>
                    <td>
                      <Input name="articulo" type="string" placeholder="Articulo" value={inputField.articulosNombre} disabled />
                    </td>
                    <td style={{ maxWidth: "60px" }}>
                      <Input name="cantidad" type="number" min="0" step="any" placeholder="Cantidad" value={inputField.cantInv} required={inputField.idInv !== ""} disabled />
                    </td>
                    <td style={{ maxWidth: "60px" }}>
                      {inputField.idInv != "" ? (
                        <Input name="cantidad" type="number" min="0" step="any" disabled placeholder="Cantidad" value={inputField.cantidad} required onChange={(event) => handleChangeInputCantidad(inputField.id, event)} />
                      ) : (
                        <Input name="cantidad" type="number" min="0" step="any" placeholder="Cantidad" value={inputField.cantidad} disabled />
                      )}
                    </td>
                    <td style={{ maxWidth: "60px" }}>
                      <Input name="precioOriginal" type="number" min="0" step="any" placeholder="PrecioOriginal" value={inputField.precioOriginal} disabled />
                    </td>
                    <td style={{ maxWidth: "60px" }}>
                      <Input style={inputField.precioOriginal - 50 > inputField.precio && !cambiarPrecio ? { backgroundColor: "#ed8c8c" } : null} name="precio" type="number" min="0" step="any" disabled placeholder="Precio" value={inputField.precio} required onChange={(event) => handleChangeInput(inputField.id, event)} />
                    </td>
                    <td style={{ maxWidth: "60px" }}>
                      <Input name="precioBruto" type="number" min="0" step="any" placeholder="PrecioBruto" value={inputField.precioBruto} disabled />
                    </td>
                    <td style={{ maxWidth: "80px" }}>
                      <Input name="total" type="number" min="0" step="any" placeholder="total" value={inputField.total} disabled />
                    </td>
                    <td>
                      <Button size="sm" color="danger" disabled={inputFields.length === 1} onClick={() => handleRemoveFields(inputField.id)} tabIndex="-1">
                        <i className="fas fa-minus"></i>
                      </Button>{" "}
                      <Button size="sm" color="info" onClick={handleAddFields} tabIndex="-1">
                        <i className="fas fa-plus"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>


          {/* Resumen Walmart */}
          {selectedArea === AREAS_WALMART && inputFields.length > 0 && (
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 16px", marginBottom: 14 }}>
              <div style={{ borderLeft: "4px solid #f59e0b", paddingLeft: 12, marginBottom: 8, color: "#92400e", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>🛒 Resumen Walmart</div>
              <Table size="sm" bordered style={{ fontSize: "0.81rem" }}>
                <thead className="thead-light">
                  <tr>
                    <th>Artículo</th>
                    <th>Precio Venta</th>
                    <th>−14.5% Comisión</th>
                    <th>−$70 Envío</th>
                    <th>+Killers</th>
                    <th>−Promos</th>
                    <th style={{ fontWeight: 700 }}>Neto</th>
                  </tr>
                </thead>
                <tbody>
                  {inputFields.filter(f => f.articulos).map((f) => {
                    const precio = parseFloat(f.precio) || 0;
                    const comision = precio * 0.145;
                    const envio = 70;
                    const killer = killersActivos.find(k => k.articulos?.some(a => a._id?.toString() === f.articulos?.toString()));
                    const promo = promoActivas.find(p => p.articulos?.some(a => a._id?.toString() === f.articulos?.toString()));
                    const killerMonto = killer ? parseFloat(killer.monto) : 0;
                    const promoMonto = promo ? (promo.tipoDescuento === "Porcentaje" ? precio * promo.descuento / 100 : parseFloat(promo.descuento)) : 0;
                    const neto = precio - comision - envio + killerMonto - promoMonto;
                    return (
                      <tr key={f.id} style={{ backgroundColor: neto < 0 ? "#fee2e2" : neto < precio * 0.1 ? "#fef9c3" : "#dcfce7" }}>
                        <td>{f.articulosNombre}</td>
                        <td>${precio.toFixed(2)}</td>
                        <td style={{ color: "#dc2626" }}>−${comision.toFixed(2)}</td>
                        <td style={{ color: "#dc2626" }}>−$70.00</td>
                        <td style={{ color: "#16a34a" }}>{killerMonto > 0 ? `+$${killerMonto.toFixed(2)}` : "—"}</td>
                        <td style={{ color: "#dc2626" }}>{promoMonto > 0 ? `−$${promoMonto.toFixed(2)}` : "—"}</td>
                        <td style={{ fontWeight: 700 }}>${neto.toFixed(2)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          )}

          {/* Acciones */}
          <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
            {validaBoton ? (
              <Button type="submit" color="success" size="sm" tabIndex="-1" onClick={savePedido}>
                💾 Guardar
              </Button>
            ) : (
              <Button type="submit" color="success" size="sm" disabled>
                💾 Guardar
              </Button>
            )}
            <Button color="danger" size="sm" href="/MenuVentas">← Regresar</Button>
          </div>
        </div>
      ) : undefined}

      {/* Modal Progreso */}
      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}><h4>Progreso</h4></ModalHeader>
        <ModalBody>
          <h4>Este proceso puede tardar varios segundos.<br />Por favor no cierre ni refresque su navegador.</h4>
          <br />
          <div className="progreso">
            <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
            <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
            <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
          </div>
        </ModalBody>
      </Modal>

      {/* Modal Cambio Precio */}
      <Modal size="sm" isOpen={modalCambiaPrecio} toggle={toggleCambiaPrecio}>
        <ModalHeader toggle={toggleCambiaPrecio}><h4>Autorizar Cortesia</h4></ModalHeader>
        <ModalBody>
          <Input bsSize="sm" type="password" placeholder="Password" value={password} required onChange={(event) => setPassword(event.target.value)} />
          <br />
          <Row>
            <Col>
              <Button type="submit" className="btn btn-success" onClick={() => autorizaCambio()}>Autorizar</Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}

export default VentaDirectaArchivoCreate;
